import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  h, toRefs, useSlots, useCssModule,
} from 'vue';

import type { PropType } from 'vue';

import SvgIcon from '@/features/shared/kit/SvgIcon.vue';
import { Nullable } from '@/features/shared/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'UiLabel',
  props: {
  prependIcon: {
    type: String as PropType<Nullable<string>>,
    default: null,
  },

  for: {
    type: String as PropType<Nullable<string>>,
    default: null,
  },

  dataQa: {
    type: String as PropType<Nullable<string>>,
    default: null,
  },

  parentClass: {
    type: String as PropType<Nullable<string>>,
    default: null,
  },
},
  setup(__props) {

const useProps = __props;



const props = toRefs(useProps);

const slots = useSlots();
const style = useCssModule();

const containerData = {
  class: [style ? style.container : null, props.parentClass.value],
};

const iconData = {
  class: style ? style.icon : null,
  props: {
    name: props.prependIcon.value,
  },
};

const labelData = {
  class: style ? style.label : null,
  for: props.for.value,
  'aria-hidden': !props.for.value,
  'data-qa': props.dataQa.value || 'ui-label',
};

const render = () => h(
  'div',
  containerData,
  [
    props.prependIcon.value ? h(SvgIcon, iconData, null) : null,
    h('label', labelData, slots.default()),
  ].filter((element) => element !== null),
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(render))
}
}

})